// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__3kg_V","bookingInfo":"TimeRange_bookingInfo__3xCJp","dateSection":"TimeRange_dateSection__2nNBK"};